import { useEffect, useState } from 'react'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import {
    KTSVG,
    toAbsoluteUrl,
} from '../../../_metronic/helpers'

import OTPInput from 'otp-input-react'
import { useLocation, useParams } from 'react-router-dom'
import { sendOTP, virifyOtp } from '../../users-section/api'
import { FullPageLoader } from '../../component/helper'
import { addLead } from './api'
import Swal from 'sweetalert2'

// Brand color palette derived from desktop logo
const brand = {
    primary: '#0046BE', // core brand blue
    primaryDark: '#00349E',
    primaryLight: '#E6EEFF',
    gradientFrom: '#EAF1FF',
    gradientTo: '#F4F8FF',
    cardGradientFrom: '#EAF1FF',
    cardGradientTo: '#D8E6FF',
    textMuted: '#6b7280',
    heading: '#1f2937',
    shadow: 'rgba(0, 70, 190, 0.1)',
    shadowStrong: 'rgba(0, 70, 190, 0.3)'
}



const leadSchema = Yup.object().shape({
    full_name: Yup.string()
        .min(2, 'Name must be at least 2 characters')
        .max(100, 'Name is too long')
        .required('Full name is required'),
    email: Yup.string()
        .email('Please enter a valid email address')
        .when('type', {
            is: 'otp', // check value of `values.type`
            then: (schema) => schema.required('Email address is required'),
            otherwise: (schema) => schema.notRequired()
        }),

    mobile: Yup.string()
        .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit mobile number')
        .required('Mobile number is required'),
    city: Yup.string()
        .min(2, 'City must be at least 2 characters')
        .max(100, 'City name is too long')
        .required('City is required'),

    pincode: Yup.string()
        .matches(/^[0-9]{6}$/, 'Please enter a valid 6-digit pincode')
        .required('Pincode is required'),

    remarks: Yup.string()
        .max(200, 'Remarks cannot exceed 200 characters')
        .required('Remarks is required'),

    products_category: Yup.array()
        .min(1, 'Please select at least one product'),
    agree: Yup.boolean().oneOf([true], 'You must agree to privacy policy and terms'),
})

const LeadGenerateFormNew = () => {
    const { project_uuid } = useParams()
    const [loading, setLoading] = useState(false)
    const [showOtp, setShowOtp] = useState(false)
    const [error, setError] = useState("")
    const [OTP, setOTP] = useState("");
    const [showSuccess, setShowSuccess] = useState(false);
    const [counter, setCounter] = useState(30); // 30 seconds countdown
    const [canResend, setCanResend] = useState(false);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const type = params.get("type")
    const utmParams = {
        utm_source: params.get("utm_source"),
        utm_medium: params.get("utm_medium"),
        utm_campaign: params.get("utm_campaign"),
    };

    const initialValues = {
        full_name: '',
        email: '',
        mobile: '',
        whatsApp: "",
        city: '',
        pincode: '',
        products_category: [],
        project_ref_key: project_uuid || '',
        utm_source: utmParams.utm_source || '',
        utm_medium: utmParams.utm_medium || '',
        utm_campaign: utmParams.utm_campaign || '',
        remarks: '',
        lead_type: "webForm",
        agree: false, // <-- Add agree field
        type: type
    }

    useEffect(() => {
        let timer;
        if (!canResend && counter > 0) {
            timer = setInterval(() => {
                setCounter((prev) => prev - 1);
            }, 1000);
        } else if (counter === 0) {
            setCanResend(true);
        }
        return () => clearInterval(timer);
    }, [counter, canResend]);

    const handleResendClick = (mobile) => {
        if (!canResend) return;

        handleSendOTP(mobile); // send OTP again
        setCounter(30); // reset timer
        setCanResend(false);
    };


    // Product options for Kitchen & Bathroom
    const kitchenProductOptions = [
        'Kitchen Faucets & Sinks',
        'Kitchen Cabinets & Storage',
        'Kitchen Countertops',
        'Water Purifiers',
        'Built-in Hobs & Chimneys'
    ]

    const bathroomProductOptions = [
        'Bathroom Faucets & Fixtures',
        'Bathroom Vanities & Cabinets',
        'Shower Systems & Panels',
        'Bathtubs & Whirlpools',
        'Toilets & Bidets'
    ]

    // const budgetRanges = [
    //     'Under $5,000',
    //     '$5,000 - $15,000',
    //     '$15,000 - $35,000',
    //     '$35,000 - $75,000',
    //     'Above $75,000'
    // ]

    // const timelineOptions = [
    //     'Immediately',
    //     'Within 2 weeks',
    //     '1-2 months',
    //     '2-4 months',
    //     '4+ months'
    // ]
    const handleSendOTP = async (number, type, key) => {
        setLoading(true);
        const otpData = {
            mobile: number,           // use parameter
            company_key: "C-IIRPL-JYCHS723",
            type: "leadForm"               // use parameter,
        };

        try {
            setError('');
            const response = await sendOTP(otpData);
            if (response.code === 1) {
                setTimeout(() => {
                    setLoading(false);
                }, 500)
                setShowOtp(true);
            } else {
                setTimeout(() => {
                    setLoading(false);
                }, 500)
                setError(response.message || 'Failed to send OTP');
            }
        } catch (err) {
            setError('Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <> {loading && <FullPageLoader />}
            <div className='lead-generator-wrapper' style={{
                background: `linear-gradient(135deg, ${brand.gradientFrom} 0%, ${brand.gradientTo} 100%)`,
                minHeight: '100vh'
            }}>
                {/* Mobile Header */}
                <div className='app-header-primary py-6 mb-3 d-xl-none' style={{
                    background: '#ffffff',
                    boxShadow: `0 0.5rem 1.5rem 0.5rem ${brand.shadow}`
                }}>
                    <div className='container-fluid px-5'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='d-flex align-items-center'>
                                <img
                                    alt='Kohler Logo'
                                    src='https://www.kohler.co.in/_next/static/media/BLOK_LOGO.00edf835.svg'
                                    className='h-45px me-5'
                                    style={{ filter: 'none' }}
                                />
                                {/* <div>
                                                <h1 className='fs-2x text-dark mb-0'>LeadGen Pro</h1>
                                                <div className='fs-5' style={{ color: '#6b7280' }}>Professional Solutions</div>
                                            </div> */}
                            </div>

                            <div style={{ background: brand.primary, color: 'white' }} className='rounded-3 p-3'>
                                <div className='fs-8'>Questions? Call us</div>
                                <div className='fs-5 fw-bold'>1-800-XXXX</div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Main Content with full-width background */}
                <div className='mx-xl-10 '>
                    <div className='card shadow-lg border-0' style={{
                        background: 'white',
                        borderRadius: '16px',
                        overflow: 'hidden'
                    }}>
                        <div className='card-body p-0'>
                            <div className='row g-0'>
                                {/* Left Side - Benefits - Hidden on mobile */}
                                <div className='col-xxl-6 col-xl-7 d-none d-xl-block' style={{
                                    background: `linear-gradient(135deg, ${brand.cardGradientFrom} 0%, ${brand.cardGradientTo} 100%)`
                                }}>
                                    <div className='p-10 p-lg-15'>
                                        {/* Logo and Header Section */}
                                        <div className='d-flex align-items-center justify-content-between mb-15'>
                                            <div className='d-flex align-items-center'>
                                                <img
                                                    alt='Kohler Logo'
                                                    src='https://www.kohler.co.in/_next/static/media/BLOK_LOGO.00edf835.svg'
                                                    className='h-60px me-5'
                                                    style={{ filter: 'none' }}
                                                />
                                                {/* <div>
                                                <h1 className='fs-2x text-dark mb-0'>LeadGen Pro</h1>
                                                <div className='fs-5' style={{ color: '#6b7280' }}>Professional Solutions</div>
                                            </div> */}
                                            </div>
                                            <div style={{ background: brand.primary, color: 'white' }} className='rounded-3 p-4'>
                                                <div className='fs-7'>Questions? Call us</div>
                                                <div className='fs-3 fw-bold'>1-XXXX-XX-XXX</div>
                                            </div>
                                        </div>

                                        <div className='mb-15'>
                                            <div className='text-center position-relative mb-17'>
                                                <h2 className='fs-2hx text-dark mb-5'>Welcome to Kohler<br />with <span style={{ color: brand.primary }}>Believing in Better</span></h2>
                                                <div className='fs-5 mb-5' style={{ color: brand.textMuted }}>
                                                    Well-being begins with each one of us through our individual journeys to experiencing our own unique version of well-being. Kohler champions the path to self-fulfillment, elevating everyday moments and inspiring standout moments that bring you back to your best you
                                                </div>
                                                {/* <div className='overlay-layer card-rounded py-3 px-6 text-white fs-6' style={{
                                                background: brand.primary,
                                                borderRadius: '12px'
                                            }}>
                                                Limited Time Offer: Free Business Consultation
                                            </div> */}
                                            </div>
                                        </div>

                                        <div className='mb-15'>
                                            <div className='d-flex flex-stack mb-8'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='symbol symbol-50px me-5'>
                                                        <div className='symbol-label' style={{ background: brand.primaryLight }}>
                                                            <KTSVG
                                                                path='/media/icons/duotune/general/gen025.svg'
                                                                className='svg-icon-2x'
                                                                style={{ color: brand.primary }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <div className='fs-5 text-dark fw-bold'>Expertly Crafted Products</div>
                                                        <div className='fs-6' style={{ color: brand.textMuted }}> High-quality kitchen & bathroom solutions built to last</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='d-flex flex-stack mb-8'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='symbol symbol-50px me-5'>
                                                        <div className='symbol-label' style={{ background: brand.primaryLight }}>
                                                            <KTSVG
                                                                path='/media/icons/duotune/general/gen013.svg'
                                                                className='svg-icon-2x'
                                                                style={{ color: brand.primary }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <div className='fs-5 text-dark fw-bold'>Style Meets Functionality</div>
                                                        <div className='fs-6' style={{ color: brand.textMuted }}>Innovative designs that make your space look and feel amazing</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='d-flex flex-stack mb-8'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='symbol symbol-50px me-5'>
                                                        <div className='symbol-label' style={{ background: brand.primaryLight }}>
                                                            <KTSVG
                                                                path='/media/icons/duotune/general/gen007.svg'
                                                                className='svg-icon-2x'
                                                                style={{ color: brand.primary }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <div className='fs-5 text-dark fw-bold'>Trusted by Homeowners </div>
                                                        <div className='fs-6' style={{ color: brand.textMuted }}>Thousands of customers love our products for their durability and elegance</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='d-flex flex-stack'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='symbol symbol-50px me-5'>
                                                        <div className='symbol-label' style={{ background: brand.primaryLight }}>
                                                            <KTSVG
                                                                path='/media/icons/duotune/general/gen043.svg'
                                                                className='svg-icon-2x'
                                                                style={{ color: brand.primary }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <div className='fs-5 text-dark fw-bold'>Easy & Hassle-Free Experience</div>
                                                        <div className='fs-6' style={{ color: brand.textMuted }}>Products ready for installation, giving you convenience and peace of mind</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='mb-15'>
                                            <h3 className='fs-2 text-dark mb-8'>Trusted by leading companies</h3>
                                            <div className='row g-5'>
                                                <div className='col-md-4'>
                                                    <div className='card h-100 hover-elevate-up border-0' style={{ background: '#f8fafc' }}>
                                                        <div className='card-body p-6 text-center'>
                                                            <div className='symbol symbol-60px mx-auto mb-4'>
                                                                <div className='symbol-label' style={{ background: brand.primary }}>
                                                                    <KTSVG path='/media/icons/duotune/general/gen032.svg' className='svg-icon-2x svg-icon-white' />
                                                                </div>
                                                            </div>
                                                            <div className='fs-2 fw-bold mb-2' style={{ color: brand.primary }}>Enterprise Security</div>
                                                            <div className='fs-6' style={{ color: brand.textMuted }}>Bank-level security protocols</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='card h-100 hover-elevate-up border-0' style={{ background: '#f8fafc' }}>
                                                        <div className='card-body p-6 text-center'>
                                                            <div className='symbol symbol-60px mx-auto mb-4'>
                                                                <div className='symbol-label' style={{ background: brand.primary }}>
                                                                    <KTSVG path='/media/icons/duotune/general/gen014.svg' className='svg-icon-2x svg-icon-white' />
                                                                </div>
                                                            </div>
                                                            <div className='fs-2 fw-bold mb-2' style={{ color: brand.primary }}>Fast Implementation</div>
                                                            <div className='fs-6' style={{ color: brand.textMuted }}>Quick deployment and setup</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='card h-100 hover-elevate-up border-0' style={{ background: '#f8fafc' }}>
                                                        <div className='card-body p-6 text-center'>
                                                            <div className='symbol symbol-60px mx-auto mb-4'>
                                                                <div className='symbol-label' style={{ background: brand.primary }}>
                                                                    <KTSVG path='/media/icons/duotune/general/gen043.svg' className='svg-icon-2x svg-icon-white' />
                                                                </div>
                                                            </div>
                                                            <div className='fs-2 fw-bold mb-2' style={{ color: brand.primary }}>24/7 Support</div>
                                                            <div className='fs-6' style={{ color: brand.textMuted }}>Round-the-clock assistance</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='separator separator-dashed my-10'></div>

                                        <div className='rounded border-0 p-10' style={{
                                            background: `linear-gradient(135deg, ${brand.primary} 0%, ${brand.primaryDark} 100%)`,
                                            color: 'white'
                                        }}>
                                            <div className='mb-5'>
                                                <div className='fs-1 fw-bold mb-3'>
                                                    Get Started Today
                                                </div>
                                            </div>
                                            <div className='fs-4 mb-5 opacity-75'>
                                                Fill out the form below and our team will get back to you within 24 hours.
                                            </div>
                                            <ul className='fs-6 fw-semibold'>
                                                <li className='mb-2 d-flex align-items-center'>
                                                    <KTSVG path='/media/icons/duotune/general/gen013.svg' className='svg-icon-3 svg-icon-white me-3' />
                                                    Premium Kitchen & Bathroom Products – Durable, stylish, and modern
                                                </li>
                                                <li className='mb-2 d-flex align-items-center'>
                                                    <KTSVG path='/media/icons/duotune/general/gen013.svg' className='svg-icon-3 svg-icon-white me-3' />
                                                    Wide Range of Options – Find the perfect fit for your space
                                                </li>
                                                <li className='mb-2 d-flex align-items-center'>
                                                    <KTSVG path='/media/icons/duotune/general/gen013.svg' className='svg-icon-3 svg-icon-white me-3' />
                                                    Innovative Designs – Combining functionality with elegance.
                                                </li>

                                                <li className='mb-2 d-flex align-items-center'>
                                                    <KTSVG path='/media/icons/duotune/general/gen013.svg' className='svg-icon-3 svg-icon-white me-3' />
                                                    Exclusive Offers & Promotions – Best deals just for you.
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Side - Form */}
                                <div className='col-xxl-6 col-xl-5 col-12'>
                                    <div style={{
                                        position: 'sticky',
                                        top: '20px',
                                        background: '#ffffff',
                                        borderRadius: '0 16px 16px 0'
                                    }}>
                                        <div className='position-relative h-100'>
                                            <div className='position-absolute top-0 start-0 w-100 h-100' style={{
                                                background: 'radial-gradient(circle at 100% 100%, rgba(0, 70, 190, 0.05) 0%, rgba(0, 70, 190, 0.02) 100%)',
                                                pointerEvents: 'none'
                                            }}></div>
                                            <div className='card-header border-0 py-8 bg-transparent'>
                                                <h3 className='card-title align-items-start flex-column'>
                                                    <span className='card-label fw-bold fs-2 mb-1' style={{ color: brand.heading }}>Get Started Today</span>
                                                    <span className='fw-semibold fs-6' style={{ color: brand.textMuted }}>Fill out the form below and our team will get back to you within 24 hours.</span>
                                                </h3>
                                            </div>
                                            <div className='p-10' style={{ position: 'relative', zIndex: 1 }}>

                                                <Formik
                                                    initialValues={initialValues}
                                                    validationSchema={leadSchema}
                                                    validationContext={{ type }}

                                                    onSubmit={async (values, { setStatus, setSubmitting, resetForm }) => {
                                                        setLoading(true);
                                                        try {


                                                            // Step 1: Send OTP if type is 'otp' and OTP not entered yet
                                                            if (type === "otp" && !OTP) {
                                                                await handleSendOTP(values.mobile);
                                                                setLoading(false);
                                                                return; // wait for user to input OTP
                                                            }

                                                            // Step 2: Verify OTP if type is 'otp' and OTP entered
                                                            if (type === "otp" && OTP) {
                                                                const verifyResponse = await virifyOtp({ mobile: values.mobile, otp: OTP });

                                                                if (Number(verifyResponse?.data?.code) === 0) {
                                                                    setError(verifyResponse.message || "OTP verification failed");
                                                                    setLoading(false);
                                                                    return;
                                                                }
                                                            }

                                                            // Step 3: If type is NOT otp → show SweetAlert confirmation before addLead
                                                            if (type !== "otp") {
                                                                const result = await Swal.fire({
                                                                    title: 'Are you sure?',
                                                                    text: 'Do you want to submit this lead?',
                                                                    icon: 'warning',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: "Confirm",
                                                                    cancelButtonText: "Cancel",
                                                                    reverseButtons: true,
                                                                    customClass: {
                                                                        confirmButton: 'btn btn-danger',
                                                                        cancelButton: 'btn btn-secondary'
                                                                    }
                                                                });

                                                                if (!result.isConfirmed) {
                                                                    setLoading(false);
                                                                    return; // user cancelled
                                                                }
                                                            }

                                                            // Step 4: Proceed to add lead
                                                            values.otp = OTP;
                                                            const response = await addLead(values);

                                                            if (response.code === 0) {
                                                                setError(response.message);
                                                            } else {
                                                                resetForm();
                                                                setShowSuccess(true);
                                                                setError("");
                                                            }
                                                        } catch (error) {
                                                            console.error(error);
                                                            setStatus("Error submitting lead. Please try again.");
                                                        } finally {
                                                            setLoading(false);
                                                            setSubmitting(false);
                                                        }
                                                    }}


                                                >
                                                    {({ errors, touched, values, setFieldValue }) => (
                                                        <Form className='form'>
                                                            <div className='row g-5 mb-8'>
                                                                {/* Full Name */}
                                                                <div className='col-12 col-sm-6'>
                                                                    <label
                                                                        className='form-label fw-semibold fs-6 mb-3'
                                                                        style={{ color: '#374151' }}
                                                                    >
                                                                        Full Name <span className='text-danger'>*</span>
                                                                    </label>
                                                                    <Field
                                                                        type='text'
                                                                        className={`form-control form-control-lg ${touched.full_name && errors.full_name ? 'is-invalid' : ''}`}
                                                                        name='full_name'
                                                                        placeholder='Lalit Pant'
                                                                        style={{
                                                                            borderColor: '#d1d5db',
                                                                            borderRadius: '8px',
                                                                            padding: '12px 16px',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    />
                                                                    {touched.full_name && errors.full_name && (
                                                                        <div className='fv-plugins-message-container'>
                                                                            <div className='fv-help-block text-danger fs-7 mt-2'>
                                                                                {errors.full_name}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* Email Address */}
                                                                <div className='col-12 col-sm-6'>
                                                                    <label
                                                                        className='form-label fw-semibold fs-6 mb-3'
                                                                        style={{ color: '#374151' }}
                                                                    >
                                                                        Email Address {(type === "otp") && <span className='text-danger'>*</span>}
                                                                    </label>
                                                                    <Field
                                                                        type='email'
                                                                        className={`form-control form-control-lg ${touched.email && errors.email ? 'is-invalid' : ''}`}
                                                                        name='email'
                                                                        placeholder='abc@gmail.com'
                                                                        style={{
                                                                            borderColor: '#d1d5db',
                                                                            borderRadius: '8px',
                                                                            padding: '12px 16px',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    />
                                                                    {touched.email && errors.email && (
                                                                        <div className='fv-plugins-message-container'>
                                                                            <div className='fv-help-block text-danger fs-7 mt-2'>
                                                                                {errors.email}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>




                                                            <div className='row g-5 mb-8'>
                                                                <div className='col-12 col-sm-6'>
                                                                    <label className='form-label fw-semibold fs-6 mb-3' style={{ color: '#374151' }}>Phone Number <span className='text-danger'>*</span> </label>
                                                                    <Field
                                                                        type='tel'
                                                                        className={`form-control form-control-lg ${touched.mobile && errors.mobile ? 'is-invalid' : ''}`}
                                                                        name='mobile'
                                                                        placeholder='555 123 456'
                                                                        style={{
                                                                            borderColor: '#d1d5db',
                                                                            borderRadius: '8px',
                                                                            padding: '12px 16px',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    />
                                                                    {touched.mobile && errors.mobile && (
                                                                        <div className='fv-plugins-message-container'>
                                                                            <div className='fv-help-block text-danger fs-7 mt-2'>{errors.mobile}</div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className='col-12 col-sm-6'>
                                                                    <label className='form-label fw-semibold fs-6 mb-3' style={{ color: '#374151' }}>
                                                                        WhatsApp
                                                                        {/* <a href="#" onClick={() => setFieldValue('whatsApp', values.mobile)} className="text-success fs-7 ms-2"> Copy from Phone</a> */}
                                                                    </label>
                                                                    <Field
                                                                        type='text'
                                                                        className={`form-control form-control-lg `}
                                                                        name='whatsApp'
                                                                        placeholder='555 123 456'
                                                                        style={{
                                                                            borderColor: '#d1d5db',
                                                                            borderRadius: '8px',
                                                                            padding: '12px 16px',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    />

                                                                </div>

                                                            </div>
                                                            <div className='row g-5 mb-8'>
                                                                {/* City */}
                                                                <div className='col-12 col-sm-6'>
                                                                    <label
                                                                        className='form-label fw-semibold fs-6 mb-3'
                                                                        style={{ color: '#374151' }}
                                                                    >
                                                                        City <span className='text-danger'>*</span>
                                                                    </label>
                                                                    <Field
                                                                        type='text'
                                                                        className={`form-control form-control-lg ${touched.city && errors.city ? 'is-invalid' : ''}`}
                                                                        name='city'
                                                                        placeholder='Enter your city'
                                                                        style={{
                                                                            borderColor: '#d1d5db',
                                                                            borderRadius: '8px',
                                                                            padding: '12px 16px',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    />
                                                                    {touched.city && errors.city && (
                                                                        <div className='fv-plugins-message-container'>
                                                                            <div className='fv-help-block text-danger fs-7 mt-2'>{errors.city}</div>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* Pincode */}
                                                                <div className='col-12 col-sm-6'>
                                                                    <label
                                                                        className='form-label fw-semibold fs-6 mb-3'
                                                                        style={{ color: '#374151' }}
                                                                    >
                                                                        Pincode <span className='text-danger'>*</span>
                                                                    </label>
                                                                    <Field
                                                                        type='text'
                                                                        className={`form-control form-control-lg ${touched.pincode && errors.pincode ? 'is-invalid' : ''}`}
                                                                        name='pincode'
                                                                        placeholder='Enter your pincode'
                                                                        style={{
                                                                            borderColor: '#d1d5db',
                                                                            borderRadius: '8px',
                                                                            padding: '12px 16px',
                                                                            fontSize: '16px'
                                                                        }}
                                                                    />
                                                                    {touched.pincode && errors.pincode && (
                                                                        <div className='fv-plugins-message-container'>
                                                                            <div className='fv-help-block text-danger fs-7 mt-2'>{errors.pincode}</div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className='mb-8'>
                                                                <label className='form-label fw-semibold fs-6 mb-4' style={{ color: '#374151' }}>Select Products Category <span className='text-danger'>*</span></label>
                                                                <div className='row g-5'>
                                                                    <div className='col-12 col-md-6'>
                                                                        <div className='fw-bold mb-3' style={{ color: brand.heading }}>Kitchen</div>
                                                                        {kitchenProductOptions.map((option) => (
                                                                            <label key={option} className='form-check form-check-custom  form-check-lg mb-3'>
                                                                                <input
                                                                                    className='form-check-input'
                                                                                    type='checkbox'
                                                                                    checked={values.products_category.includes(option)}
                                                                                    onChange={() => {
                                                                                        const current = values.products_category
                                                                                        const next = current.includes(option)
                                                                                            ? current.filter((s) => s !== option)
                                                                                            : [...current, option]
                                                                                        setFieldValue('products_category', next)
                                                                                    }}
                                                                                />
                                                                                <span className='form-check-label fs-7 fw-semibold'>{option}</span>
                                                                            </label>
                                                                        ))}
                                                                    </div>
                                                                    <div className='col-12 col-md-6'>
                                                                        <div className='fw-bold mb-3' style={{ color: brand.heading }}>Bathroom</div>
                                                                        {bathroomProductOptions.map((option) => (
                                                                            <label key={option} className='form-check form-check-custom form-check-lg mb-3'>
                                                                                <input
                                                                                    className='form-check-input'
                                                                                    type='checkbox'
                                                                                    checked={values.products_category.includes(option)}
                                                                                    onChange={() => {
                                                                                        const current = values.products_category
                                                                                        const next = current.includes(option)
                                                                                            ? current.filter((s) => s !== option)
                                                                                            : [...current, option]
                                                                                        setFieldValue('products_category', next)
                                                                                    }}
                                                                                />
                                                                                <span className='form-check-label fs-7 fw-semibold'>{option}</span>
                                                                            </label>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                {errors.products_category && (
                                                                    <div className='fv-plugins-message-container mt-2'>
                                                                        <div className='fv-help-block text-danger fs-7'>{errors.products_category}</div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className='mb-8'>
                                                                <label className='form-label fw-semibold fs-6 mb-3' style={{ color: '#374151' }}>
                                                                    Tell us about your requirements <span className='text-danger'>*</span>
                                                                </label>
                                                                <Field
                                                                    as='textarea'
                                                                    className={`form-control form-control-lg ${touched.remarks && errors.remarks ? 'is-invalid' : ''}`}
                                                                    name='remarks'
                                                                    placeholder='Add any remarks or additional details here...'
                                                                    rows='4'
                                                                    style={{
                                                                        borderColor: '#d1d5db',
                                                                        borderRadius: '8px',
                                                                        padding: '12px 16px',
                                                                        fontSize: '16px',
                                                                        resize: 'vertical'
                                                                    }}
                                                                />
                                                                {touched.remarks && errors.remarks && (
                                                                    <div className='fv-plugins-message-container'>
                                                                        <div className='fv-help-block text-danger fs-7 mt-2'>{errors.remarks}</div>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className='mb-8'>
                                                                <label className='d-flex align-items-center  gap-2'>
                                                                    <Field
                                                                        type="checkbox"
                                                                        name="agree"
                                                                        className="form-check-input"
                                                                    />
                                                                    <span className='fs-7 fw-semibold' style={{ color: brand.textMuted }}>
                                                                        By submitting this form, you agree to our{' '}
                                                                        <div style={{ color: brand.primary, textDecoration: 'none' }}>privacy policy</div> and{' '}
                                                                        <div style={{ color: brand.primary, textDecoration: 'none' }}>terms of service</div>.
                                                                    </span>
                                                                </label>
                                                                {touched.agree && errors.agree && (
                                                                    <div className='fv-help-block text-danger fs-7 mt-2'>{errors.agree}</div>
                                                                )}
                                                            </div>
                                                            {error && <div className='text-danger text-center  fw-semibold fs-6 mb-3'> <i className='fas text-danger fa-exclamation-triangle'></i> {error}</div>}

                                                            {showSuccess ? (
                                                                <div className="mb-10 p-4 rounded-3 shadow-sm bg-light">
                                                                    <div className="text-center  py-5">
                                                                        <img src={toAbsoluteUrl("/media/images/new-success.png")} alt="Success" style={{ width: 150, marginBottom: 16 }} />
                                                                        <h5 className="fs-2 fw-bold text-success mb-3">Thank you!</h5>
                                                                        <div className="fs-4 text-dark mb-2">Your request has been received successfully.</div>
                                                                        <div className="fs-4 text-muted">Our team will get back to you within 24 hours.</div>
                                                                        <a
                                                                            href="https://www.kohler.co.in/"
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="btn btn-light-info fw-semibold px-6 py-3 mt-6"
                                                                        >
                                                                            Continue exploring Kohler
                                                                            <i className="bi bi-arrow-right text-info fs-4 fw-bolder ms-2"></i> {/* Bootstrap Icons arrow */}
                                                                        </a>


                                                                    </div>
                                                                </div>
                                                            ) : showOtp ? (
                                                                <div className="mb-10 p-4 rounded-3 shadow-sm bg-light">
                                                                    <div className="text-center py-10">
                                                                        <h5 className="fw-semibold text-center mb-4 fs-3">
                                                                            Enter 4-digit OTP
                                                                        </h5>
                                                                        <div className="d-flex justify-content-center gap-3 mb-3">
                                                                            <OTPInput
                                                                                value={OTP}
                                                                                onChange={setOTP}
                                                                                inputClassName="form-control form-control-solid rounded-3 border-2 border-info text-center fs-4 fw-semibold shadow-sm h-40px w-40px"
                                                                                autoFocus
                                                                                OTPLength={4}
                                                                                otpType="number"
                                                                                disabled={false}
                                                                            />
                                                                        </div>
                                                                        <small className="text-muted d-block text-center mb-4">
                                                                            Didn’t receive it?{" "}
                                                                            {canResend ? (
                                                                                <div
                                                                                    className="fw-semibold text-danger"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        handleResendClick(values.mobile);
                                                                                    }}
                                                                                >
                                                                                    Resend OTP
                                                                                </div>
                                                                            ) : (
                                                                                <span className="fw-semibold text-gray-500 fs-7">
                                                                                    Resend in {counter}s
                                                                                </span>
                                                                            )}
                                                                        </small>
                                                                        <button
                                                                            type="submit"
                                                                            className="btn btn-lg w-100 text-white fw-semibold shadow rounded-3 border-0"
                                                                            style={{
                                                                                background: 'linear-gradient(90deg, #5a67d8, #6b46c1)',
                                                                                transition: 'all 0.2s ease'
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                if (!loading) {
                                                                                    e.target.style.background = 'linear-gradient(90deg, #6b46c1, #5a67d8)';
                                                                                    e.target.style.transform = 'translateY(-2px)';
                                                                                    e.target.style.boxShadow = '0 6px 16px rgba(90,103,216,.3)';
                                                                                }
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                if (!loading) {
                                                                                    e.target.style.background = 'linear-gradient(90deg, #5a67d8, #6b46c1)';
                                                                                    e.target.style.transform = 'translateY(0)';
                                                                                    e.target.style.boxShadow = '';
                                                                                }
                                                                            }}
                                                                            disabled={loading || OTP.length !== 4}
                                                                        >
                                                                            {!loading ? (
                                                                                <span className="indicator-label">Verify OTP</span>
                                                                            ) : (
                                                                                <span className="indicator-progress">
                                                                                    Please wait...
                                                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                                                </span>
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-lg w-100 mb-5 border-0"
                                                                    style={{
                                                                        background: brand.primary,
                                                                        color: 'white',
                                                                        borderRadius: '8px',
                                                                        padding: '16px 24px',
                                                                        fontSize: '16px',
                                                                        fontWeight: '600',
                                                                        boxShadow: `0 4px 12px ${brand.shadowStrong}`,
                                                                        transition: 'all 0.2s ease'
                                                                    }}
                                                                    disabled={loading}
                                                                    onMouseEnter={(e) => {
                                                                        if (!loading) {
                                                                            e.target.style.background = brand.primaryDark
                                                                            e.target.style.transform = 'translateY(-1px)'
                                                                        }
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        if (!loading) {
                                                                            e.target.style.background = brand.primary
                                                                            e.target.style.transform = 'translateY(0)'
                                                                        }
                                                                    }}
                                                                >
                                                                    Get Your Free Consultation
                                                                </button>
                                                            )}
                                                        </Form>
                                                    )}
                                                </Formik>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default LeadGenerateFormNew